import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

const LanguageContext = createContext(null);

function detectDefault() {
  const saved = localStorage.getItem("boussole_lang");
  if (saved === "fr" || saved === "en") return saved;
  const nav = (navigator.language || "fr").toLowerCase();
  return nav.startsWith("en") ? "en" : "fr";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectDefault);

  const setLang = useCallback((l) => {
    localStorage.setItem("boussole_lang", l);
    setLangState(l);
  }, []);

  const toggle = useCallback(() => {
    setLang(lang === "fr" ? "en" : "fr");
  }, [lang, setLang]);

  const value = useMemo(() => ({ lang, setLang, toggle }), [lang, setLang, toggle]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
